import actionTypes from './index';

export default () => ({ type: actionTypes.RESET_MODAL });
